// extracted by mini-css-extract-plugin
export default {"container":"gN-z","topReviewHeading":"hN-z","criticalReview":"iN-z","favorableReview":"jN-z","vsSeparator":"kN-z"};